// Copyright (c) Docugami, Inc. All rights reserved.

import { number } from "prop-types";
import { Grabber, GrabberType } from "sdv/components/GrabberComponent";
import { Point } from "sdv/Types";
import { Box, scaleBox } from "store/shared_types";

export const grabberConstants = {
    strokeWidth: number
}

export function createGrabbers(boxes: Box[]): Grabber[] {
    const firstBox = boxes[0];
    const lastBox = boxes[boxes.length - 1];
    if (!firstBox || !lastBox) {
        return [];
    }

    return [createLeftGrabber(firstBox), createTopGrabber(firstBox), createRightGrabber(lastBox), createBottomGrabber(lastBox)];
}

export function createRightGrabber(box: Box): Grabber {
    const boxHeight = box.bottom - box.top;
    const centerPoint: Point = { x: box.right, y: box.top + boxHeight / 2 }
    const offset = boxHeight * .1;
    const visualBox: Box = {
        left: centerPoint.x + 1,
        right: centerPoint.x + 6,
        top: box.top + offset,
        bottom: box.bottom - offset,
        page: box.page
    }

    return {
        type: GrabberType.Right,
        visual: visualBox,
        bounds: scaleBox(visualBox, 1.5)
    }
}

export function createLeftGrabber(box: Box): Grabber {
    const boxHeight = box.bottom - box.top;
    const centerPosition: Point = { x: box.left, y: box.top + boxHeight / 2 }
    const offset = boxHeight * .1;
    const visualBox: Box = {
        left: centerPosition.x - 6,
        right: centerPosition.x - 1,
        top: box.top + offset,
        bottom: box.bottom - offset,
        page: box.page
    }

    return {
        type: GrabberType.Left,
        visual: visualBox,
        bounds: scaleBox(visualBox, 1.5)
    }
}

export function createTopGrabber(box: Box, lineWidth: number = 4): Grabber {
    const width = box.right - box.left;
    const centerPoint: Point = { x: box.left + width / 2, y: box.top }
    const visualBox: Box = {
        left: centerPoint.x - 4,
        right: centerPoint.x + 4,
        top: centerPoint.y - 4,
        bottom: centerPoint.y + 4,
        page: box.page
    }

    return {
        type: GrabberType.Top,
        visual: visualBox,
        bounds: scaleBox(visualBox, 1.5)
    }
}

export function createBottomGrabber(box: Box, lineWidth: number = 4): Grabber {
    const width = box.right - box.left;
    const centerPoint: Point = { x: box.left + width / 2, y: box.bottom }
    const visualBox: Box = {
        left: centerPoint.x - 4,
        right: centerPoint.x + 4,
        top: centerPoint.y - 4,
        bottom: centerPoint.y + 4,
        page: box.page
    }

    return {
        type: GrabberType.Bottom,
        visual: visualBox,
        bounds: scaleBox(visualBox, 1.5)
    }
}
